<template>
  <div class="phase-banner">
		<div class="grid-wrap relative">
			<div class="grid-row">
				<div class="grid-col grid-col--soft grid-xsmall-12">
					<p>
						<span class="phase__tag">Beta</span>&nbsp;
						<span class="phase__summary">This is a new service, your <a href="/contact">feedback</a> will help us to improve it.</span>
					</p>
					</div>
				</div>
			</div>	
	</div>
</template>

<script>
export default {
  name: 'PhaseBanner'
}
</script>